import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import { Chart, ChartProvider, ChartLegend } from '@facet-wealth/design';
import ChartTooltip from './ChartTooltip';
import { convertChartDataResourceToDataSet } from './utils';

const UpdatedScenarioChartWithEmphasizedItems = ({
  chartDataResource,
  onClick,
  showLegend,
  selectedDataSetId,
  chartDataSourceIdsToShow,
  yAxisLabel,
  xAxisLabel,
}) => {
  const dataset = React.useMemo(() => {
    return convertChartDataResourceToDataSet(chartDataResource, selectedDataSetId, chartDataSourceIdsToShow, yAxisLabel, xAxisLabel);
  }, [chartDataResource?.instanceId(), selectedDataSetId, chartDataSourceIdsToShow]);

  const yAxisTicks = (chartDataResource.attr('yAxisTicks') ?? []).map(tick => +tick);
  const hideXAxisTicks = chartDataResource?.isTruthy('hideXAxisTicks');
  const yAxisGridlines = chartDataResource?.isTruthy('yAxisGridlines');

  return (
    <ChartProvider key={chartDataResource?.instanceId()} dataset={dataset}>
      <Chart
        tooltip={ChartTooltip}
        onClick={onClick}
        yAxisGridlines={yAxisGridlines}
        yAxisTicks={yAxisTicks.length > 0 ? yAxisTicks : undefined}
        xAxisTicks={hideXAxisTicks ? [] : undefined}
        alwaysShowY0
      />
      {showLegend ? (
        <Box paddingBottom={2}>
          <ChartLegend />
        </Box>
      ) : null}
    </ChartProvider>
  );
};

export default UpdatedScenarioChartWithEmphasizedItems;
